import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-finalizacao',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatRadioModule,
    MatInputModule,
  ],
  templateUrl: './modal-finalizacao.component.html',
  styleUrl: './modal-finalizacao.component.scss'
})
export class ModalFinalizacaoComponent implements OnInit {
  modalAviso!: boolean;
  possuiAcoes!: boolean;
  titulo: string = "";
  conteudo: string = "";
  acao: string = "";

  constructor(
    public dialogRef: MatDialogRef<ModalFinalizacaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.modalAviso = this.data.isAviso;
    this.titulo = this.data.titulo;
    this.conteudo = this.data.conteudo;
    this.acao = this.data.acao;
    this.possuiAcoes = this.data.possuiAcoes;
  }

  onConfirm() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
